
const Missing = () => {
  return (
    <div>Missing</div>
  )
}

export default Missing